import React from 'react'

import NotificationModule from '../../components/Notifications/Notifications'

function index() {

  return (
    <NotificationModule />
  )
}

export default index;